var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"41f6e3d10beb804dd1baa4d04e89da8f633788c6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["home-waste-web@clearabee"]={id:"41f6e3d10beb804dd1baa4d04e89da8f633788c6"};
      